import { Card, Col, Input, Button, Row, Form, Spinner } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import { useState, useEffect } from "react"
import { toast } from "react-hot-toast"
import Select from "react-select"
import { InputOption } from "../../utils"
import { ArrowLeft } from "react-feather"
import { statusOption } from "../../stockOptions"
import { getStockOption, getStocktById, postAddStock, putStock } from "../../myApiCenter"
import MainNav from "../MainNav/MainNav"
import "../../styles/AddStock.css"

const AddStock = () => {
   const { id } = useParams()
   const navigate = useNavigate()
   const [loading, setloading] = useState(false)
   const [data, setdata] = useState({
      currentExpiryDetail: {
         symboltoken: "",
         tradingsymbol: "",
         instrumenttype: "",
         exchange: "",
         lotsize: 0,
         expiry: ""
      },
      stockBrokerDetail: {
         symboltoken: "",
         tradingsymbol: "",
         instrumenttype: "",
         exchange: "",
         lotsize: 0,
         expiry: ""
      },
      nextExpiryDetail: {
         symboltoken: "",
         tradingsymbol: "",
         instrumenttype: "",
         exchange: "",
         lotsize: 0,
         expiry: ""
      },
      isActiveFromAdmin: true,
      marginPoint: 0,
      lastTradedValue: 0,
      name: "",
      status: "BUY",
      movingAverage: 0,
      lastClose: 0,
      isRolledOver: false
   })

   const [futureOptions, setFutureOptions] = useState([])
   const [stockBrokerOptions, setstockBrokerOptions] = useState([])
   const [optionsLoaded, setOptionsLoaded] = useState({
      future: false,
      stock: false
   })

   const getData = async () => {
      try {
         const j = await getStocktById(id)
         setdata(j.data.stock)

         if (j.data.stock.name) {
            await Promise.all([getFutureOptions(j.data.stock.name), getStockBrokerOptionsData(j.data.stock.name)])
         }
      } catch (error) {
         console.log(error)
      }
   }

   const getFutureOptions = async (stockName = data.name) => {
      if (!stockName) return

      try {
         toast.loading("fetching future options")
         const j = await getStockOption(stockName, "fut")
         setFutureOptions(j || [])
         setOptionsLoaded((prev) => ({ ...prev, future: true }))
      } catch (error) {
         console.log(error)
         setFutureOptions([])
      } finally {
         toast.dismiss()
      }
   }

   const getStockBrokerOptionsData = async (stockName = data.name) => {
      if (!stockName) return

      try {
         toast.loading("fetching stock broker options")
         const j = await getStockOption(stockName, "stock")
         setstockBrokerOptions(j || [])
         setOptionsLoaded((prev) => ({ ...prev, stock: true }))
      } catch (error) {
         console.log(error)
         setstockBrokerOptions([])
      } finally {
         toast.dismiss()
      }
   }

   const handleStockNameChange = (e) => {
      const newName = e.target.value
      setdata({ ...data, name: newName })

      setFutureOptions([])
      setstockBrokerOptions([])
      setOptionsLoaded({ future: false, stock: false })
   }

   const submitHandler = async (e) => {
      e.preventDefault()
      if (data) {
         try {
            setloading(true)
            let j
            if (id) {
               j = await putStock(id, data)
            } else {
               j = await postAddStock(data)
            }
            j && navigate("/stocks")
         } finally {
            setloading(false)
         }
      } else {
         toast.error("please fill all required fields")
      }
   }

   useEffect(() => {
      if (id) {
         getData()
      }
   }, [id])

   return (
      <>
         <MainNav />
         <div className="add-stock-container-outer">
            <div className="add-stock-container">
               <Card className="add-stock-card">
                  <div className="header">
                     <button className="back-btn" onClick={() => navigate(-1)}>
                        <ArrowLeft size={20} />
                     </button>
                     <h4>{id ? "Edit Stock" : "Add Stock"}</h4>
                  </div>

                  <Form onSubmit={submitHandler}>
                     <Row>
                        <Col xs={12} md={6}>
                           <div className="form-group side-by-side">
                              <label>
                                 Stock Name <span className="required">*</span>
                              </label>
                              <Input value={data.name} required onChange={handleStockNameChange} type="text" placeholder="Enter stock name" />
                           </div>
                        </Col>
                     </Row>

                     <div className="section">
                        <h5>Stock Broker Detail</h5>
                        <Row>
                           <Col xs={12} md={6}>
                              <div className="form-group side-by-side">
                                 <label>Select Stock Broker</label>
                                 <Select
                                    value={
                                       (data?.stockBrokerDetail?.tradingsymbol &&
                                          stockBrokerOptions.find((option) => option.tradingsymbol === data?.stockBrokerDetail?.tradingsymbol)) ||
                                       null
                                    }
                                    options={stockBrokerOptions}
                                    onChange={(e) => setdata({ ...data, stockBrokerDetail: e || {} })}
                                    components={{ Option: InputOption }}
                                    className="react-select"
                                    placeholder="Select from list"
                                    onFocus={() => (optionsLoaded.stock ? null : getStockBrokerOptionsData())}
                                    isDisabled={!data.name}
                                 />
                              </div>
                           </Col>
                        </Row>
                     </div>

                     <div className="section">
                        <h5>Current Expiry Detail (Future)</h5>
                        <Row>
                           <Col xs={12} md={6}>
                              <div className="form-group side-by-side">
                                 <label>Select Current Expiry</label>
                                 <Select
                                    value={
                                       (data?.currentExpiryDetail?.tradingsymbol &&
                                          futureOptions.find((option) => option.tradingsymbol === data?.currentExpiryDetail?.tradingsymbol)) ||
                                       null
                                    }
                                    options={futureOptions}
                                    onChange={(e) => setdata({ ...data, currentExpiryDetail: e || {} })}
                                    components={{ Option: InputOption }}
                                    className="react-select"
                                    placeholder="Select from list"
                                    onFocus={() => (optionsLoaded.future ? null : getFutureOptions())}
                                    isDisabled={!data.name}
                                 />
                              </div>
                           </Col>
                           <Col xs={12} md={3}>
                              <div className="form-group side-by-side">
                                 <label>Expiry Date :</label>
                                 <span>{data?.currentExpiryDetail?.expiry || "----"}</span>
                              </div>
                           </Col>
                           <Col xs={12} md={3}>
                              <div className="form-group side-by-side">
                                 <label>Lot Size :</label>
                                 <span>{data?.currentExpiryDetail?.lotsize || "----"}</span>
                              </div>
                           </Col>
                        </Row>
                     </div>

                     <div className="section">
                        <h5>Next Expiry Detail (Future)</h5>
                        <Row>
                           <Col xs={12} md={6}>
                              <div className="form-group side-by-side">
                                 <label>Select Next Expiry</label>
                                 <Select
                                    value={
                                       (data?.nextExpiryDetail?.tradingsymbol &&
                                          futureOptions.find((option) => option.tradingsymbol === data?.nextExpiryDetail?.tradingsymbol)) ||
                                       null
                                    }
                                    options={futureOptions}
                                    onChange={(e) => setdata({ ...data, nextExpiryDetail: e || {} })}
                                    components={{ Option: InputOption }}
                                    className="react-select"
                                    placeholder="Select from list"
                                    onFocus={() => (optionsLoaded.future ? null : getFutureOptions())}
                                    isDisabled={!data.name}
                                 />
                              </div>
                           </Col>
                           <Col xs={12} md={3}>
                              <div className="form-group side-by-side">
                                 <label>Expiry Date :</label>
                                 <span>{data?.nextExpiryDetail?.expiry || "----"}</span>
                              </div>
                           </Col>
                           <Col xs={12} md={3}>
                              <div className="form-group side-by-side">
                                 <label>Lot Size :</label>
                                 <span>{data?.nextExpiryDetail?.lotsize || "----"}</span>
                              </div>
                           </Col>
                        </Row>
                     </div>

                     <Row>
                        <Col xs={12} md={6}>
                           <div className="form-group side-by-side">
                              <label>Status</label>
                              <Select
                                 value={(data.status && statusOption.find((option) => option.value === data.status)) || null}
                                 options={statusOption}
                                 onChange={(e) => setdata({ ...data, status: e?.value || "BUY" })}
                                 components={{ Option: InputOption }}
                                 className="react-select"
                                 placeholder="Select status"
                              />
                           </div>
                        </Col>
                        <Col xs={12} md={6}>
                           <div className="form-group side-by-side">
                              <label>Margin Point</label>
                              <Input
                                 value={data.marginPoint}
                                 required
                                 onChange={(e) => setdata({ ...data, marginPoint: parseFloat(e.target.value) || 0 })}
                                 type="number"
                                 step="0.1"
                                 min="0"
                                 placeholder="Enter margin point"
                              />
                           </div>
                        </Col>
                     </Row>

                     <Row>
                        <Col xs={12} md={6} className=" d-flex justify-content-between px-4">
                           <label>Is Rolled Over</label>
                           <div className="form-switch form-check-success">
                              <Input
                                 type="switch"
                                 onChange={(e) => setdata({ ...data, isRolledOver: e.target.checked })}
                                 checked={data.isRolledOver}
                              />
                           </div>
                        </Col>
                        <Col xs={12} md={6} className=" d-flex justify-content-between px-4">
                           <label>Active</label>
                           <div className="form-switch form-check-success">
                              <Input
                                 type="switch"
                                 onChange={(e) => setdata({ ...data, isActiveFromAdmin: e.target.checked })}
                                 checked={data.isActiveFromAdmin}
                              />
                           </div>
                        </Col>
                     </Row>

                     <Button type="submit" color="primary" disabled={loading} className="submit-btn">
                        {loading ? (
                           <>
                              <Spinner size="sm" /> Saving...
                           </>
                        ) : (
                           "Save Stock"
                        )}
                     </Button>
                  </Form>
               </Card>
            </div>
         </div>
      </>
   )
}

export default AddStock
